module.exports = __webpack_public_path__ + "media/images/article/twitter-2afe7018c52f2c34cfb4cb7c02cd8123.png";